import cacheService from "@/services/cache";

// @deprecated, use cacheService.clearLocalStorage() instead
export function clearLocalStorage() {
    cacheService.clearLocalStorage();
}



// WEBPACK FOOTER //
// ./src/utils/storage.js